<template>
  <main class="products_page">
    <header class="products_header">
      <p class="products_eyebrow">
        Forever Link
      </p>
      <h1>{{ $t('products.title') }}</h1>
      <span class="products_header_line" />
    </header>

    <section
      v-if="products.length"
      class="products_grid"
      :aria-label="$t('products.title')"
    >
      <button
        v-for="product in products"
        :key="product.id"
        type="button"
        class="product_card"
        @click="showNoAccess"
      >
        <span class="product_image_box">
          <img
            :src="product.image"
            :alt="product.title"
            class="product_image"
          >
        </span>
        <span class="product_title">{{ product.title }}</span>
        <span class="product_sales">{{ $t('products.sales') }} {{ product.sales }}</span>
      </button>
    </section>

    <section
      v-else-if="!loading"
      class="empty_state"
    >
      {{ $t('products.empty') }}
    </section>
  </main>
</template>

<script>
import Fetch from '../../utils/fetch';
import { Toast } from 'vant';

export default {
  name: 'Products',
  data() {
    return {
      loading: false,
      products: [],
    };
  },
  created() {
    this.$parent.footer('products', true);
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.replace('/login?redirect=/products');
      return;
    }
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      this.loading = true;
      Fetch('/product/index').then((response) => {
        this.products = response.data && Array.isArray(response.data.list) ? response.data.list : [];
      }).catch(() => {}).finally(() => {
        this.loading = false;
      });
    },
    showNoAccess() {
      Toast({
        background: '#873126',
        duration: 2200,
        message: this.$t('products.noAccess'),
      });
    },
  },
};
</script>

<style lang="less" scoped>
.products_page {
  min-height: 100vh;
  padding: 24px 14px calc(88px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #533126;
  background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5);
}

.products_header { margin: 0 4px 18px; text-align: center; }
.products_eyebrow { margin: 0; color: #b9802e; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; }
.products_header h1 { margin: 5px 0 7px; color: #873126; font-size: 20px; font-weight: 600; line-height: 28px; }
.products_header_line { display: block; width: 56px; height: 1px; margin: 0 auto; background: linear-gradient(90deg, transparent, #b9802e, transparent); }

.products_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px 11px;
  max-width: 620px;
  margin: 0 auto;
}

.product_card {
  min-width: 0;
  padding: 6px 6px 10px;
  overflow: hidden;
  border: 1px solid rgba(190, 139, 52, .46);
  border-radius: 13px;
  background: #fffdf8;
  box-shadow: 0 10px 20px rgba(125, 82, 35, .08);
  color: inherit;
  font: inherit;
  text-align: left;
}

.product_card:active { transform: translateY(1px); border-color: rgba(166, 35, 61, .62); background: #fff0ed; }
.product_image_box { display: block; aspect-ratio: 5 / 4; overflow: hidden; border-radius: 9px; background: #fff7df; }
.product_image { display: block; width: 100%; height: 100%; object-fit: contain; }
.product_title, .product_sales { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.product_title { margin: 9px 4px 3px; color: #873126; font-size: 13px; font-weight: 600; line-height: 19px; }
.product_sales { margin: 0 4px; color: #815c45; font-size: 11px; line-height: 16px; }
.empty_state { margin-top: 90px; color: #815c45; font-size: 13px; text-align: center; }

@media (min-width: 520px) {
  .products_page { padding-right: 24px; padding-left: 24px; }
}
</style>
